import { Container } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

const Home = () => {
  return (
    <Container>
      <h1 className="center">Welcome to Stubminer</h1>
      <div className="align-left">
        To get started:
        <ul>
          <li>
            <a href="https://www.youtube.com/playlist?list=PL_py24H3UDPuBuQlG4gdJxznmoHayc_BI">
              Click here to watch the tutorial videos
            </a>
          </li>
          <li>
            Sign up for a subscription by clicking{" "}
            <LinkContainer to="/account">
              <a href="/account">here</a>
            </LinkContainer>
            , or clicking on your email address in the top right corner of this
            screen.
          </li>
          <li>
            Download the Automate android app by{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.llamalab.automate&hl=en_US&gl=US&pli=1"
              target="_new"
            >
              clicking here
            </a>
            .
          </li>
          <li>
            Download our Automate scripts{" "}
            <LinkContainer to="/downloads">
              <a href="/downloads">here</a>
            </LinkContainer>
            .
          </li>
          <li>
            Follow the instructions in the tutorial videos to set up Automate
            and our scripts.
          </li>
          <li>Profit!</li>
        </ul>
      </div>
    </Container>
  );
};

export default Home;
